import React, { useContext } from 'react';
import styled from 'styled-components';
import AppointmentBookingInternalContext from '../../../AppointmentBookingInternalContext';
import CoopSelectContext from '../CoopSelectContext';

const HiddenViewMlsLink: React.FC = () => {
  const { listing } = useContext(AppointmentBookingInternalContext);
  const { coop } = useContext(CoopSelectContext);

  if (!coop || !coop.uid) return null;

  return (
    <StyledHiddenMlsLink
      href={`/rets/${
        listing!.org.id
      }/appointment_redirect?listingId=${listing!.id}&uid=${coop.uid}${
        coop.mls ? `&mls=${coop.mls}` : ''
      }`}
      target="_blank"
      rel="noreferrer"
      data-cy="view-hidden-mls-link"
    >
      View MLS Link
    </StyledHiddenMlsLink>
  );
};

const StyledHiddenMlsLink = styled.a`
  color: white;
  float: right;
  &:hover {
    color: white;
  }
`;

export default HiddenViewMlsLink;
